export interface RunSettings {
  playerCount?: number;
  playerNames?: string[];
  testStage?: boolean;
}
export function normalizePlayerNames(count: number, names: string[] = []): string[] {
  return Array.from({ length: count }, (_, i) =>
    String(names[i] ?? '').replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, 16) || `Jucător ${i + 1}`);
}
